/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventSchema } from './EventSchema';
import {
    EventSchemaFromJSON,
    EventSchemaFromJSONTyped,
    EventSchemaToJSON,
} from './EventSchema';

/**
 * 
 * @export
 * @interface PageEventSchema
 */
export interface PageEventSchema {
    /**
     * 
     * @type {Array<EventSchema>}
     * @memberof PageEventSchema
     */
    items: Array<EventSchema>;
    /**
     * 
     * @type {number}
     * @memberof PageEventSchema
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PageEventSchema
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PageEventSchema
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof PageEventSchema
     */
    pages: number;
}

/**
 * Check if a given object implements the PageEventSchema interface.
 */
export function instanceOfPageEventSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "pages" in value;

    return isInstance;
}

export function PageEventSchemaFromJSON(json: any): PageEventSchema {
    return PageEventSchemaFromJSONTyped(json, false);
}

export function PageEventSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageEventSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(EventSchemaFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'size': json['size'],
        'pages': json['pages'],
    };
}

export function PageEventSchemaToJSON(value?: PageEventSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(EventSchemaToJSON)),
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}

